import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { Trust } from '@features/contacts/models/trust';
import { TrustService } from '@features/contacts/services/trust.service';
import { TagService, TagEntityType } from '@features/opportunities/services/tag.service';
import { commandEvent } from '@shared/components/load/command/command.component';

import { Content, TrustDetailsComponent } from '../trust-details.component';

@Component({
  selector: 'spark-contacts-trust-new',
  templateUrl: '../trust-details.component.html'
})
export class TrustNewComponent extends TrustDetailsComponent implements OnInit {
  readonly isNewEntity = true;

  get saveLabel(): string {
    return 'Create';
  }

  get title(): string {
    return 'New Trust Contact';
  }

  constructor(
    trustService: TrustService,
    fb: FormBuilder,
    private tagService: TagService
  ) {
    super(trustService, fb);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.update$ = commandEvent(this.change$, (delta) =>
      this.trustService.updateTrust(this.trustId, delta).pipe(
        switchMap(() => {
          if (this.pendingTags.length === 0) {
            return of({});
          }
          const requests = this.pendingTags.map(tag => ({ tagId: tag.tagId, tagName: tag.tagName }));
          return this.tagService.addTagsToEntity(
            TagEntityType.Trusts, this.trustId, requests
          ).pipe(map(() => ({})));
        })
      )
    );
  }

  content(): Observable<Content> {
    return of({
      trust: {} as Trust.Model,
      contacts: []
    });
  }
}
